import type { ReactNode } from 'react';
import { styled } from 'goober';

import claudeLogoSrc from '@/assets/images/claude-logo.png';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Stack } from '@/ui/line/line';

interface ClaudeMcpConnectorHeaderProps {
  badge?: ReactNode;
  subtitle: ReactNode;
  title: ReactNode;
  titleExtras?: ReactNode;
}

export const ClaudeMcpConnectorHeader = ({
  badge,
  subtitle,
  title,
  titleExtras,
}: ClaudeMcpConnectorHeaderProps) => (
  <Flexbox alignItems="flex-start" fullWidth gap="12px">
    <ConnectorIconBadge>
      <ConnectorLogo alt="Claude logo" src={claudeLogoSrc} />
    </ConnectorIconBadge>
    <TitleStack gap="2px" minWidth="0">
      {titleExtras ? (
        <TitleRow alignItems="center" gap="8px" wrap="wrap">
          <CardTitle>{title}</CardTitle>
          {titleExtras}
        </TitleRow>
      ) : (
        <CardTitle>{title}</CardTitle>
      )}
      <CardSubtitle>{subtitle}</CardSubtitle>
    </TitleStack>
    {badge}
  </Flexbox>
);

export const EnvironmentBadge = styled('span')`
  background-color: ${({ theme }) => theme.colors.spotlight.icon.amber.bg};
  border: 1px solid ${({ theme }) => theme.colors.spotlight.icon.amber.color};
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.spotlight.icon.amber.color};
  font-family: ${({ theme }) => theme.fonts.neue};
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  text-transform: uppercase;
`;

const ConnectorIconBadge = styled('div')`
  background-color: ${({ theme }) => theme.colors.spotlight.icon.amber.bg};
  border-radius: 8px;
  flex-shrink: 0;
  height: 40px;
  overflow: hidden;
  width: 40px;
`;

const ConnectorLogo = styled('img')`
  display: block;
  height: 100%;
  object-fit: contain;
  width: 100%;
`;

const CardTitle = styled('h3')`
  color: ${({ theme }) => theme.colors.basics.black};
  font-family: ${({ theme }) => theme.fonts.wallop};
  font-size: 15px;
  font-weight: 600;
  margin: 0;
`;

const CardSubtitle = styled('p')`
  color: ${({ theme }) => theme.colors.gray.c10};
  font-family: ${({ theme }) => theme.fonts.neue};
  font-size: 12.5px;
  line-height: 1.4;
  margin: 0;
`;

const TitleStack = styled(Stack)`
  flex: 1;
`;

const TitleRow = styled(Flexbox)``;
